import {Injectable} from '@angular/core';
import {GraphOptions} from "./models/graph-options";
import {GraphModel} from "./models/graph.model";
import {map} from "rxjs/operators";
import {plainToInstance} from "class-transformer";
import {MesApiService} from "common-shared";
import {Observable} from "rxjs";
import {EntityTypes} from "web-shared";

@Injectable({
  providedIn: 'root'
})
export class GraphService extends MesApiService {
  options: GraphOptions = this.getOptions();
  visibilityChoices = [EntityTypes.General, EntityTypes.IntermediateItem, EntityTypes.Resource];

  constructor() {
    super('Graph', 'manufacturing');
  }

  getOptions() {
    return plainToInstance(GraphOptions, (JSON.parse(localStorage.getItem('graph-options')) as GraphOptions) ?? new GraphOptions());
  }

  setOptions(options: GraphOptions) {
    this.options = options;
    localStorage.setItem('graph-options', JSON.stringify(this.options));
  }

  getItemGraph(id: string, options: GraphOptions = null): Observable<GraphModel> {
    options = options ?? this.options;
    options.Id = id;
    return this.addGet<GraphOptions, GraphModel>(options, {
      action: 'GetGraph'
    }).pipe(map(value => {
      return plainToInstance(GraphModel, value.data);
    }));
  }

  getItemGroupGraph(id: string, options: GraphOptions = null) {
    options = options ?? this.options;
    options.Id = id;
    return this.addGet<GraphOptions, GraphModel>(options, {
      action: 'GetItemGroupGraph'
    }).pipe(map(value => {
      return plainToInstance(GraphModel, value.data);
    }));
  }

  getResourceGraph(id: string, options: GraphOptions = null) {
    options = options ?? this.options;
    options.Id = id;
    return this.addGet<GraphOptions, GraphModel>(options, {
      action: 'GetResourceGraph'
    }).pipe(map(value => {
      return plainToInstance(GraphModel, value.data);
    }));
  }

  getAllFinishedItemsGraph(options: GraphOptions = null) {
    return this.addGet<GraphOptions, GraphModel>(options ?? this.options, {
      action: 'AllFinishedItemsGraph'
    }).pipe(map(value => {
      return plainToInstance(GraphModel, value.data);
    }));
  }
}
